// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3RK_4","top":"styles_top__3_GF4"};